"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const useChangeReviewer_1 = require("hooks/api/useChangeReviewer");
const useIntersectionObserver_1 = __importDefault(require("hooks/useIntersectionObserver"));
const HelperUtils_1 = require("utils/HelperUtils");
const ProfileType_1 = __importDefault(require("components/design-system/ProfileType"));
const Switcher_1 = __importDefault(require("components/design-system/Switcher"));
const Table_1 = __importDefault(require("components/design-system/table/Table"));
const ListEmptyState_1 = __importDefault(require("components/shared/ListEmptyState"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const TooltipContainer_1 = __importDefault(require("components/shared/Tooltips/TooltipContainer"));
const RevieweeFoundContent = ({ setMetaData, phases }) => {
    const [sort, setSort] = (0, react_1.useState)({
        sortColumn: 'name',
        sortDirection: 'asc'
    });
    const [selectedSwitch, setSelectedSwitch] = (0, react_1.useState)('changed');
    const { id } = (0, react_router_1.useParams)();
    const intersectTarget = (0, react_1.createRef)();
    const headers = [
        {
            name: 'reviewee',
            widthClass: 'w-[200px]',
            grow: true,
            sort: {
                sortColumn: sort === null || sort === void 0 ? void 0 : sort.sortColumn,
                sortDirection: sort === null || sort === void 0 ? void 0 : sort.sortDirection,
                onSort: (direction) => setSort({ sortColumn: sort === null || sort === void 0 ? void 0 : sort.sortColumn, sortDirection: direction })
            }
        },
        { name: 'nip', widthClass: 'w-[120px]' }
    ];
    if (phases.includes('manager_review')) {
        headers.push({ name: 'previous manager', widthClass: 'w-[224px]' }, { name: 'new manager', widthClass: 'w-[224px]' });
    }
    if (phases.includes('indirect_manager_review')) {
        headers.push({ name: 'previous indirect', widthClass: 'w-[224px]' }, { name: 'new indirect', widthClass: 'w-[224px]' });
    }
    const params = {
        type: selectedSwitch == 'changed' ? 'user_changed' : 'user_unchanged',
        sortColumn: sort.sortColumn,
        sortDirection: sort.sortDirection,
        limit: 10
    };
    const { data: rData, metadata, isLoading, hasNextPage, isFetchingNextPage, isFetching, fetchNextPage } = (0, useChangeReviewer_1.useChangeReviewer)(id, params);
    if (metadata) {
        setMetaData && setMetaData(metadata);
    }
    (0, useIntersectionObserver_1.default)({
        target: intersectTarget,
        threshold: 0.5,
        onIntersect: (entry) => {
            if (!entry.isIntersecting)
                return;
            if (!hasNextPage)
                return;
            if (isFetching)
                return;
            fetchNextPage();
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Switcher_1.default, { options: [
                { id: 'changed', name: 'Changed' },
                { id: 'no_changes', name: 'No Changes' }
            ], selectedOption: selectedSwitch, onChange: (selected) => setSelectedSwitch(selected), textCustomClass: "typography-button" }),
        react_1.default.createElement(Table_1.default, { headers: headers },
            isLoading &&
                [...new Array(10)].map((_, index) => {
                    return react_1.default.createElement(Table_1.default.LoadingRow, { key: index });
                }),
            !isLoading && (rData === null || rData === void 0 ? void 0 : rData.length) == 0 && (react_1.default.createElement(ListEmptyState_1.default, { fullHeight: true, size: "large", emptyIcon: "icon-no-user", title: (0, HelperUtils_1.getObjectiveLocale)('No user found') })),
            rData &&
                rData.map((dt, index) => {
                    const manager = dt.managerReview;
                    const indirect = dt.indirectManagerReview;
                    return (react_1.default.createElement(Table_1.default.Row, { key: index, useRowHover: false },
                        react_1.default.createElement(Table_1.default.Column, { customClass: "w-[200px]", grow: true },
                            react_1.default.createElement(ProfileType_1.default, { customClass: "min-w-[0px] items-center", tooltipClassContainer: "min-w-[0px]", user: dt.target, title: dt.target.name, subtitle: dt.target.jobTitle, titleClassName: "typography-h400", subtitleClassName: "typography-h100 typography-secondary" })),
                        react_1.default.createElement(Table_1.default.Column, { widthClass: "w-[120px]" },
                            react_1.default.createElement("span", { className: "typography-paragraph text-n-900" }, dt.target.externalId)),
                        phases.includes('manager_review') && (react_1.default.createElement(react_1.default.Fragment, null,
                            manager.previousActor.message ? (react_1.default.createElement(InfoColumn, { message: manager.previousActor.message })) : (react_1.default.createElement(Table_1.default.Column, { widthClass: "w-[224px]" },
                                react_1.default.createElement(ManagerColumn, { manager: manager.previousActor }))),
                            manager.newActor.message ? (react_1.default.createElement(InfoColumn, { message: manager.newActor.message })) : (react_1.default.createElement(Table_1.default.Column, { widthClass: "w-[224px]", customClass: !manager.newActor.message ? 'bg-base-30024' : '' },
                                react_1.default.createElement(ManagerColumn, { manager: manager.newActor }))))),
                        phases.includes('indirect_manager_review') && (react_1.default.createElement(react_1.default.Fragment, null,
                            indirect.previousActor.message ? (react_1.default.createElement(InfoColumn, { message: indirect.previousActor.message })) : (react_1.default.createElement(Table_1.default.Column, { widthClass: "w-[224px]" },
                                react_1.default.createElement(ManagerColumn, { manager: indirect.previousActor }))),
                            indirect.newActor.message ? (react_1.default.createElement(InfoColumn, { message: indirect.newActor.message })) : (react_1.default.createElement(Table_1.default.Column, { widthClass: "w-[224px]", customClass: !indirect.newActor.message ? 'bg-base-30024' : '' },
                                react_1.default.createElement(ManagerColumn, { manager: indirect.newActor })))))));
                }),
            isFetchingNextPage && react_1.default.createElement(Table_1.default.LoadingRow, null),
            react_1.default.createElement("div", { ref: intersectTarget }))));
};
const ManagerColumn = ({ manager }) => {
    return (react_1.default.createElement("div", { className: "flex flex-col" },
        react_1.default.createElement("p", { className: "typography-h400 text-n-900" }, manager.name),
        react_1.default.createElement("span", { className: "typography-h100 text-n-800" }, manager.job_title)));
};
const InfoColumn = ({ message }) => {
    const NO_REVIEWER = 'No reviewer';
    const MULTIPLE_REVIEWERS_FOUND = 'Multiple reviewers found';
    let showTooltip = false;
    let tooltipMessage = '';
    if (message == NO_REVIEWER) {
        showTooltip = true;
        tooltipMessage = (0, HelperUtils_1.getObjectiveLocale)('This user has no reviewer before, the new reviewer will not be applied. ');
    }
    else if (message == MULTIPLE_REVIEWERS_FOUND) {
        showTooltip = true;
        tooltipMessage = (0, HelperUtils_1.getObjectiveLocale)('This user has multiple reviewers, the new reviewer will not be applied.');
    }
    return (react_1.default.createElement(TooltipContainer_1.default, { text: tooltipMessage, show: showTooltip, classContainer: "cursor-pointer" },
        react_1.default.createElement(Table_1.default.Column, { widthClass: "w-[224px]" },
            react_1.default.createElement("span", { className: "typography-paragraph text-n-700" }, message),
            showTooltip && (react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-info", size: 16, fillColor: "var(--n-600)", customClass: "ml-[4px]" })))));
};
exports.default = RevieweeFoundContent;
